import {
  JournalEntryContainerType,
  JournalEntryItemType,
  JournalEntryType,
} from "model/journal.model";
import React, { useState } from "react";
import { UsersMap } from "store/types/tenant-context.types";
import { useTranslation } from "react-i18next";
import Timeline from "@cc/react-components/Timeline";
import Collapse from "@cc/react-components/Collapse";
import TimelineItemDetails from "./TimelineItemDetails";
import { ActionDate } from "model/action-date.model";
import Alert from "@cc/react-components/Alert";

export interface Props {
  containersByYear: { [year: number]: Array<JournalEntryContainerType> };
  journalEntriesByContainer: { [containerId: number]: Array<JournalEntryType> };
  journalEntryItems: Array<JournalEntryItemType>;
  users: UsersMap;
}

export const TimelineItem = ({
  containersByYear,
  journalEntriesByContainer,
  journalEntryItems,
  users,
}: Props) => {
  const [t] = useTranslation();
  const [openedTimelineItem, setOpenedTimelineItem] = useState<number>();

  const renderYear = (
    year: string,
    containers: Array<JournalEntryContainerType>,
    journalEntriesByContainer: {
      [containerId: number]: Array<JournalEntryType>;
    },
    users: UsersMap
  ) => {
    return (
      <React.Fragment key={year}>
        {<Timeline.Title className="ml-2" title={year} />}
        {renderContainers(
          containers,
          journalEntriesByContainer,
          journalEntryItems,
          users
        )}
      </React.Fragment>
    );
  };

  const renderContainers = (
    containers: Array<JournalEntryContainerType>,
    journalEntriesByContainer: {
      [containerId: number]: Array<JournalEntryType>;
    },
    journalEntryItems: Array<JournalEntryItemType>,
    users: UsersMap
  ) => {
    return containers.map(
      (container: JournalEntryContainerType, key: number) => {
        const entries: Array<JournalEntryType> =
          journalEntriesByContainer[container.id];
        const author = users[container.authorId];
        const actionDate = container.actionDate;
        return (
          <Timeline.Item
            key={key}
            icon="consultation"
            title={t("timelineModal." + container.type)}
            date={ActionDate.toString(actionDate)}
            onClick={() => {
              if (openedTimelineItem === container.id) {
                setOpenedTimelineItem(0);
              } else {
                setOpenedTimelineItem(container.id);
              }
            }}
          >
            <Collapse open={openedTimelineItem === container.id}>
              <div>
                <TimelineItemDetails
                  journalEntries={entries}
                  journalEntryItems={journalEntryItems}
                  user={author}
                />
              </div>
            </Collapse>
          </Timeline.Item>
        );
      }
    );
  };

  return (
    <>
      {!containersByYear || Object.keys(containersByYear).length === 0 ? (
        <Alert variant="info">{t("timeline.emptyList")}</Alert>
      ) : (
        <Timeline>
          {containersByYear &&
            Object.entries(containersByYear)
              .reverse()
              .map(([year, containers]) => {
                return renderYear(
                  year,
                  containers,
                  journalEntriesByContainer,
                  users
                );
              })}
        </Timeline>
      )}
    </>
  );
};

export default TimelineItem;
